import amplitude from 'amplitude-js'

export default {
	install (Vue, options) {
		Vue.prototype.amplitude = amplitude
		Vue.prototype.amplitudeIdentify = new amplitude.Identify()
	}
}
